export enum Messages {
    OPERATION_SUCCESS = "nav.operationSuccess"
}